<template>
  <div class="home">
    <v-card :loading="isLoading">
      <v-card-text>
        <v-row>
          <v-col :xl="2" :lg="3" :md="4" :sm="6" :xs="12" v-for="room in rooms" :key="room.id">
            <RoomCard :data="room"></RoomCard>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import api from '@/plugins/APIWrapper';
import RoomCard from '@/components/RoomCard.vue';

export default {
  name: 'rooms',
  data() {
    return {
      rooms: [],
      isLoading: 'success',
    };
  },
  components: {
    RoomCard,
  },
  async mounted() {
    try {
      this.rooms = await api.getRooms();
      this.isLoading = false;
    } catch (e) {
      console.error(e);
      this.isLoading = 'error';
    }
  },
};
</script>
